import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=6fe3a2c1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe3a2c1')) {
      api.createRecord('6fe3a2c1', component.options)
    } else {
      api.reload('6fe3a2c1', component.options)
    }
    module.hot.accept("./Meetings.vue?vue&type=template&id=6fe3a2c1&", function () {
      api.rerender('6fe3a2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/meetings/Meetings.vue"
export default component.exports